import React, { Component } from "react";
import BsyIconBtn from "../BsyIconBtn";
import BsyAlertListDetail from "../BsyAlertListDetail";
import OperationRecord from "./OperationRecord"
import BsyDialog from "../BsyDialog";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyDateTime from "../BsyDateTime";
import BsyAlert from "../BsyAlert";
import BsySwitchBtn from "../BsySwitchBtn";
import BsyTextEditor from "../BsyTextEditor";
import { BsyUtils } from "../../utils/Utils";
import { dayjsUtils } from "../../utils/dayjsUtils";

class UserViewDetailCont extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || {},
      projectId: props.projectId || "",
      selectVal: props.selectVal || {}
    }
  }

  addProjectName = "";
  addProjectDesc = "";

  addChangeProjectGroupName = (e) => {
    this.addProjectName = e.target.value.replace(/\s+/g, ' ');
    e.target.value = this.addProjectName;
  }

  validateString = (inputString) => {
    let regex = /^[\u4e00-\u9fa5\w\s]+$/;
    // \u4e00-\u9fa5 表示中文字符范围，\w 表示字母、数字、下划线，\s表示空格

    // 使用test()方法检查输入字符串是否符合正则表达式模式
    return regex.test(inputString);
  }

  addPostponeDesc = "";

  addChangePostponeDesc = (e) => {
    this.addPostponeDesc = e.target.value.replace(/[\r\n]/g, '');
    e.target.value = this.addPostponeDesc;
  }

  addChangeProjectDesc = (e) => {
    this.addProjectDesc = e.target.value.replace(/[\r\n]/g, '');
    e.target.value = this.addProjectDesc;
  }

  addReleaseProjectName = () => {
    const { data_id, username } = this.state.data;
    this.addProjectName = username;
    BsyDialog({
      title: React.language('nickname.update'),
      height: 490,
      width: 460,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: () => {
        return <div className={"addProjectContent"}>
          <div className="addItem name">
            <div className="itemTitle">
              <span><b>*</b>{React.language('project.user.name')}</span>
            </div>
            <div className="itemValue">
              <input autoFocus={true} type="text" maxLength={128} defaultValue={this.addProjectName} onBlur={this.addChangeProjectGroupName}
                placeholder={React.language("placeholder.project.user.name")} />
            </div>
          </div>
        </div>
      },
      onOk: () => {
        if (this.addProjectName === "" || this.addProjectName === " ") {
          tipAlert({
            type: "warning",
            msg: React.language("placeholder.project.user.name")
          })
          return false
        }
        if (!this.validateString(this.addProjectName)) {
          tipAlert({
            type: "warning",
            msg: React.language("virtual.add.name.tip")
          })
          return false
        }
        React.axios("/dashboard/standard_user_update", { _id: this.state.projectId, data_id, username: this.addProjectName }).then((res) => {
          if (res.data.code === 200) {
            this.state.data.username = this.addProjectName;
            this.setState({ data: this.state.data });
            tipAlert({
              type: "success",
              msg: React.language("update.success")
            })
          }
          this.props.userManagementContext.loadData();
        })
      }
    })
  }

  addReleaseProjectDesc = () => {
    const { data_id, remark } = this.state.data;
    this.addProjectDesc = remark;

    BsyDialog({
      title: React.language('edit.note'),
      height: 490,
      width: 460,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: () => {
        return <div className={"addProjectContent"}>
          <div className="addItem remark">
            <div className="itemTitle">
              <span>{React.language('contact.note')}</span>
            </div>
            <div className="itemValue">
              <textarea autoFocus={true} maxLength={1024} defaultValue={this.addProjectDesc} onBlur={this.addChangeProjectDesc}
                placeholder={React.language("placeholder.contact.note")} />
            </div>
          </div>
        </div>
      },
      onOk: () => {
        React.axios("/dashboard/standard_user_update", { _id: this.state.projectId, data_id, remark: this.addProjectDesc }).then((res) => {
          if (res.data.code === 200) {
            this.state.data.remark = this.addProjectDesc;
            this.setState({ data: this.state.data });
            tipAlert({
              type: "success",
              msg: React.language("update.success")
            })
          }

          this.props.userManagementContext.loadData();
        })
      }
    })
  }

  clearDebugKey = () => {
    const { data_id, } = this.state.data;
    BsyAlert({
      title: React.language("project.debug.token.clear"),
      type: "query",
      iconColor: "var(--bsy-base-error-color)",
      text4Ok: React.language("ok"),
      OkType: "pureRed",
      text4Cancel: React.language("cancel"),
      ok: () => {
        const d = { _id: this.state.projectId, data_id, "delEditToken": true }
        React.axios("/dashboard/standard_user_update", d).then((res) => {
          if (res.data.code === 200) {
            this.setState({
              data: {
                ...this.state.data,
                editToken: null,
                editTokenStatus: null,
                editTokenTime: null
              }
            })
            tipAlert({
              type: "success",
              msg: React.language("update.success")
            })
          }
          this.props.userManagementContext.loadData();
        })
      }
    })
  }

  // 停止恢复更新
  stopResetUpdate = () => {
    const { data_id, isRenew } = this.state.data;
    BsyAlert({
      title: isRenew ?
        React.language("project.update.stop.tip") :
        React.language("project.update.restart.tip"),
      type: "query",
      iconColor: "var(--bsy-base-error-color)",
      text4Ok: React.language("ok"),
      OkType: "pureRed",
      text4Cancel: React.language("cancel"),
      ok: () => {
        const d = { _id: this.state.projectId, data_id, "renew": isRenew ? false : true }
        React.axios("/dashboard/standard_user_update", d).then((res) => {
          if (res.data.code === 200) {
            this.setState({
              data: {
                ...this.state.data,
                isRenew: isRenew ? false : true,
              }
            })
            tipAlert({
              type: "success",
              msg: React.language("update.success")
            })
          }
          this.props.userManagementContext.loadData();
        })
      }
    })
  }


  // 清空解绑的key
  clearUnBindKey = () => {
    const { data_id } = this.state.data;
    BsyAlert({
      title: React.language("project.unbind.key.clear"),
      type: "query",
      iconColor: "var(--bsy-base-error-color)",
      text4Ok: React.language("ok"),
      OkType: "pureRed",
      text4Cancel: React.language("cancel"),
      ok: () => {
        const d = { _id: this.state.projectId, data_id, delUnbindKey: true }
        React.axios("/dashboard/standard_user_update", d).then((res) => {
          if (res.data.code === 200) {
            this.setState({
              data: {
                ...this.state.data,
                unBindKey: "",
              }
            })
            tipAlert({
              type: "success",
              msg: React.language("update.success")
            })
          }
          this.props.userManagementContext.loadData();
        })
      }
    })
  }

  generateDebugKey = () => {

    const { data_id, } = this.state.data;
    let editTokenTime = 1;
    BsyDialog({
      title: React.language('project.debug.token.generate'),
      height: 400,
      width: 460,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: () => {
        return <div className={"addProjectContent"}>
          <div className="addItem name">
            <div className="itemTitle">
              <span>{React.language('effective.time')}</span>

            </div>
            <div className="itemValue debug-token">
              <BsyTextEditor
                value={editTokenTime}
                onAfterEdit={val => {
                  editTokenTime = val;
                }}></BsyTextEditor>
              <div className="hour">{React.language('to.hour')}</div>
            </div>
            <div style={{
              fontWeight: 500,
              fontSize: 14,
              color: "#4D609F",
              marginTop: 10
            }}>有效单位为小时，最大999小时，-1为永久</div>
          </div>
        </div>
      },
      onOk: () => {

        if (editTokenTime === "0") {
          tipAlert({
            type: "warning",
            msg: React.language("project.debug.token.effective.time.error")
          })
          return false;
        }

        React.axios("/dashboard/standard_user_update", {
          _id: this.state.projectId, data_id,
          editToken: true,
          editTokenTime: editTokenTime,
        }).then((res) => {
          if (res.data.code === 200) {
            this.setState({
              data: {
                ...this.state.data,
                editTokenTime: res.data.time,
                editToken: res.data.token,
                editTokenStatus: 0
              }
            })
            tipAlert({
              type: "success",
              msg: res.data.msg || React.language("update.success")
            })
          }

          this.props.userManagementContext.loadData();
        })
      }
    })
  }

  getTimeContext = (t) => {
    this.timeDate = t;
  }

  unbindSwitch = false;

  switchChange = (e) => {
    this.unbindSwitch = e;
  }

  render() {
    const { data } = this.state;
    const { data_id, status } = data;
    this.unbindSwitch = status !== "3";
    return <div className="UserViewDetailCont">
      <div className="contHeader">
        <span className="title">{React.language('project.user.detail')}</span>
        <i className="icon-close-large" onClick={() => {
          this.props.onRemoveRoot();
        }}></i>
      </div>
      <div className="contBody">
        <div className="item-line">
          <div className="line-left">
            <div className="line-title">{React.language('user.site')}</div>
            <div className="line-content">{data.sitedomain}</div>
          </div>
        </div>
        <div className="item-line">
          <div className="line-left">
            <div className="line-title">{React.language('user.account')}</div>
            <div className="line-content">{data.account}</div>
          </div>
        </div>
        <div className="item-line">
          <div className="line-left">
            <div className="line-title">{React.language('user.name')}</div>
            <div className="line-content">{data.username}</div>
          </div>
          <div className="line-right" onClick={this.addReleaseProjectName}>
            <span className="status-1">{React.language("nickname.update")}</span>
          </div>
        </div>
        <div className="item-line">
          <div className="line-left">
            <div className="line-title">{React.language('Expire.date')}</div>
            <div className="line-content">{data.expireTime ? BsyUtils.date2Str(dayjsUtils.timeToTZ(data.expireTime), "yyyy-MM-dd HH:mm:ss") : React.language("permanent")}</div>
          </div>
        </div>
        <div className="item-line">
          <div className="line-left">
            <div className="line-title">{React.language('begin.install.time')}</div>
            <div className="line-content">{BsyUtils.date2Str(dayjsUtils.timeToTZ(data.installTime), "yyyy-MM-dd HH:mm:ss")}</div>
          </div>
        </div>
        <div className="item-line">
          <div className="line-left">
            <div className="line-title">{React.language('end.update.time')}</div>
            <div className="line-content">{BsyUtils.date2Str(dayjsUtils.timeToTZ(data.installUpdateTime), "yyyy-MM-dd HH:mm:ss")}</div>
          </div>
        </div>
        <div className="item-line">
          <div className="line-left">
            <div className="line-title">{React.language('project.version')}</div>
            <div className="line-content">{data.version}</div>
          </div>
        </div>
        <div className="item-line">
          <div className="line-left">
            <div className="line-title">{React.language('project.note')}</div>
            <div className="line-content">{data.remark}</div>
          </div>
          <div className="line-right" onClick={this.addReleaseProjectDesc}>
            <span className="status-1">{React.language("edit.note")}</span>
          </div>
        </div>
        <div className="item-line">
          <div className="line-left">
            <div className="line-title">{React.language('project.state')}</div>
            <div className={`line-content `}>
              <span className={`status-${data.status}`}>{data.statusText}</span>
            </div>
          </div>
        </div>
        {
          data.status === 3 ? "" : data.unBindKey ? <div className="item-line">
            <div className="line-left">
              <div className="line-title">{React.language('project.unbind.key')}</div>
              <div className={`line-content`}>{data.unBindKey}</div>
            </div>
            <div className="line-right">
              <span
                className="status-red"
                style={{
                  marginLeft: 10,
                  cursor: "pointer"
                }} onClick={this.clearUnBindKey}>
                {
                  React.language("clear")
                }
              </span>
            </div>
          </div> : ''
        }
        {
          data.status === 3 ? "" : <div className="item-line">
            <div className="line-left">
              <div className="line-title">{React.language('project.debug.token.title')}</div>
              <div className={`line-content`}>
                {
                  data.editToken ? <>
                    <span style={{ marginRight: 8 }}>{React.language('project.debug.token', { token: data.editToken })}</span>
                    <span className="usedst" >{
                      data.editTokenStatus === 1 ? React.language("usedst") : data.editTokenTime === -1 ? React.language('project.debug.token.permanent')
                        : React.language('project.debug.token.time', { time: data.editTokenTime })
                    }</span>
                    {/* {
                      data.editTokenStatus === 1 ? <span className="usedst" >{React.language("usedst")}</span> : data.editTokenTime === -1 ? React.language('project.debug.token.permanent')
                        : React.language('project.debug.token.time', { time: data.editTokenTime })} */}
                  </> : ""
                }
              </div>
            </div>
            <div className="line-right">
              {
                data.editToken ? <span
                  className="status-red"
                  style={{
                    marginLeft: 10,
                    cursor: "pointer"
                  }} onClick={this.clearDebugKey}>
                  {React.language("clear")}
                </span> : ''
              }
              <span
                className="status-1"
                style={{
                  marginLeft: 10,
                  cursor: "pointer"
                }} onClick={this.generateDebugKey}>
                {React.language("generate")}
              </span>
            </div>
          </div>
        }
        {
          data.status === 3 ? "" : <div className="item-line">
            <div className="line-left">
              <div className="line-title">{React.language('project.update.state')}</div>
              <div className={`line-content `}>
                {
                  // <span className={`${data.isRenew ? "status-1" : "status-2"}`}>{data.isRenew ?
                  //   React.language(`project.update.state.ing`) :
                  //   React.language("project.update.stop.ing")
                  // }</span>
                }
              </div>
            </div>
            <div className="line-right">
              <span
                className={`${data.isRenew ? "status-2" : "status-1"}`}
                style={{
                  marginLeft: 10,
                  cursor: "pointer"
                }} onClick={this.stopResetUpdate}>
                {data.isRenew ?
                  React.language("project.update.stop") :
                  React.language("project.update.restart")}
              </span>
            </div>
          </div>
        }
      </div>
      <div className="contFooter">
        <div className="left-group">
          <BsyIconBtn
            text={React.language("postpone")}
            click={(event) => {
              this.addPostponeDesc = "";
              BsyDialog({
                title: React.language('user.postpone'),
                height: 490,
                width: 460,
                okText: React.language("save"),
                cancelText: React.language("cancel"),
                onContentCreate: () => {
                  const { expireTime } = this.state.data;
                  return <div className={"addProjectContent"}>
                    <div className="addItem name">
                      <div className="itemTitle">
                        <span>{React.language('postpone.time')}</span>
                        <span className="itemMsg">{React.language('maturity.time.msg')}</span>
                      </div>
                      <div className="itemValue">
                        <BsyDateTime
                          key={"BsyDateTimeLimit" + new Date().getTime()}
                          width={'100%'}
                          height={36}
                          value={expireTime ? new Date(expireTime).getTime() : null}
                          theme={this.props.theme}
                          format={'yyyy-MM-dd HH:mm:ss'}
                          width4number={'auto'}
                          waterMark={React.language("placeholder.postpone.time")}
                          onStopEdit={e1 => {
                            this.maturityTime = this.timeDate.state.value;
                          }}
                          getContext={this.getTimeContext}
                        />
                      </div>
                    </div>
                    <div className="addItem remark">
                      <div className="itemTitle">
                        <span>{React.language('postpone.note')}</span>
                      </div>
                      <div className="itemValue">
                        <textarea maxLength={1024} onChange={this.addChangePostponeDesc}
                          placeholder={React.language("placeholder.postpone.note")} />
                      </div>
                    </div>
                  </div>
                },
                onOk: () => {
                  React.axios("/dashboard/standard_user_update", { _id: this.state.projectId, data_id, expireRemark: this.addPostponeDesc, expireTime: this.maturityTime ? this.maturityTime / 1000 : "" }).then((res) => {
                    if (res.data.code === 200) {
                      this.state.data.expireTime = this.addProjectDesc;
                      let t = "";
                      if (this.maturityTime) {
                        const d = new Date(this.maturityTime);
                        t += d.getFullYear() + "-";
                        t += (d.getMonth() + 1) + "-";
                        t += d.getDate() + " ";
                        t += d.getHours() + ":";
                        t += d.getMinutes() + ":";
                        t += d.getSeconds();
                      } else {
                        t = null;
                      }
                      this.state.data.expireTime = t;
                      this.setState({ data: this.state.data });
                      tipAlert({
                        type: "success",
                        msg: React.language("update.success")
                      })
                    }

                    this.props.userManagementContext.loadData();
                  })
                }
              })
            }}
            type={"white borderBlue"}
            mode={window.mode}
          />
          <BsyIconBtn
            key={status}
            text={status === "5" ? React.language("restore") : React.language("disable")}
            click={(event) => {
              BsyAlert({
                title: status === "5" ? React.language("query.restore.title", { name: data.username }) : React.language("query.disable.title", { name: data.username }),
                // msg: status === "5" ? "" : React.language("query.disable.msg"),
                type: "query",
                iconColor: status === "5" ? "#0265ff" : "var(--bsy-base-error-color)",
                text4Ok: React.language("ok"),
                OkType: status === "5" ? "blue" : "pureRed",
                text4Cancel: React.language("cancel"),
                ok: () => {
                  let d = {};
                  if (status === "5") {
                    d = { _id: this.state.projectId, data_id, restore: true }
                  } else {
                    d = { _id: this.state.projectId, data_id, forbid: true }
                  }
                  React.axios("/dashboard/standard_user_update", d).then((res) => {
                    if (res.data.code === 200) {
                      this.state.data.status = res.data.status;
                      this.setState({ data: this.state.data })
                      tipAlert({
                        type: "success",
                        msg: React.language("update.success")
                      })
                    }

                    this.props.userManagementContext.loadData();
                  })
                }
              })
            }}
            type={status === "5" ? "white borderBlue" : "red"}
            mode={window.mode}
          />
          {
            data.unBindKey ? '' : data.status === 1 ? <BsyIconBtn
              text={React.language("unbind.management")}
              click={(event) => {
                BsyDialog({
                  title: React.language('unbind.management'),
                  height: 200,
                  width: 460,
                  okText: React.language("unbind.key"),
                  cancelText: React.language("cancel"),
                  onContentCreate: () => {
                    return <div className={"unbindManagementContent"}>
                      <div className="lineMsg">
                        {React.language('unbind.management.msg')}
                      </div>
                    </div>
                  },
                  onOk: () => {
                    React.axios("/dashboard/standard_user_update",
                      { _id: this.state.projectId, data_id, unbind: true }).then((res) => {
                        if (res.data.code === 200) {
                          this.setState({
                            data: {
                              ...this.state.data,
                              unBindKey: res.data.key
                            }
                          })
                          tipAlert({
                            type: "success",
                            msg: res.data.msg || React.language("update.success")
                          })
                        }

                        this.props.userManagementContext.loadData();
                      })
                  }
                })
              }}
              type={"red"}
              mode={window.mode}
            /> : ''
          }
          <BsyIconBtn
            text={React.language("data.operation.record")}
            click={(event) => {
              this.props.onRemoveRoot()
              BsyAlertListDetail({
                type: "custom",
                width: 1000,
                createContent: (e) => {
                  return <OperationRecord userManagementContext={this.props.userManagementContext} selectVal={this.state.selectVal} projectId={this.state.projectId} data={data} onRemoveRoot={e.props && e.props.onRemoveRoot} />
                }
              })
            }}
            type={"white borderBlue"}
            mode={window.mode}
          />
        </div>


      </div>
    </div>
  }
}

export default UserViewDetailCont;